import { Property } from 'csstype'
import React from 'react'

export const Grid: React.FC = (props) => (
  <div css={{ display: 'grid' }} {...props} />
)

interface ColumnsProps {
  columns?: number
  align?: Property.AlignItems
  justify?: Property.JustifyItems
  gap?: Property.Gap<number>
}

export const Columns: React.FC<ColumnsProps> = ({
  columns,
  align = 'center',
  justify = 'start',
  gap = 0,
  ...rest
}) => (
  <Grid
    css={[
      {
        alignItems: align,
        justifyItems: justify,
        gap: gap
      },
      columns
        ? {
            gridTemplateColumns: `repeat(${columns}, 1fr)`
          }
        : { gridAutoColumns: 'auto', gridAutoFlow: 'column' }
    ]}
    {...rest}
  />
)

interface ColumnProps {
  as?: React.FunctionComponent | React.ComponentClass | string
  span?: number
  alignSelf?: Property.AlignSelf
  justifySelf?: Property.JustifySelf
  placeSelf?: Property.PlaceSelf
}

export const Column: React.FC<ColumnProps> = ({
  as: As = 'div',
  span = 1,
  alignSelf,
  justifySelf,
  placeSelf,
  ...rest
}) => (
  <As
    css={
      Boolean(span) && [
        {
          gridColumn: `span ${span}`,
          alignSelf,
          justifySelf,
          placeSelf
        }
      ]
    }
    {...rest}
  />
)
